export default __webpack_public_path__ + "static/media/plan-inactive.a76b164e.png";